/**
 * Which cards in a horizontal case row are the "edge" cards: up to the two
 * cards nearest each end of the visible window. The row arrows reveal only
 * while one of these is hovered (see CaseStudiesPage.css).
 *
 * `cards` are { left, width } in the scroller's content coordinates (each
 * card's offsetLeft/offsetWidth, with the scroller as offsetParent).
 * `viewLeft`/`viewRight` bound the visible window inside the row's side
 * inset, so a card only peeking into the gutter does not count as visible.
 *
 * Returns { left: number[], right: number[] } of card indices; both empty
 * when no card is visible.
 */
export function edgeVisibleIndices(cards, viewLeft, viewRight) {
  const visible = [];
  cards.forEach((card, i) => {
    if (card.left + card.width > viewLeft + 1 && card.left < viewRight - 1) {
      visible.push(i);
    }
  });
  if (visible.length === 0) return { left: [], right: [] };

  const first = visible[0];
  const last = visible[visible.length - 1];
  const left = [];
  for (let i = first; i <= Math.min(first + 1, last); i++) left.push(i);
  const right = [];
  for (let i = Math.max(last - 1, first); i <= last; i++) right.push(i);
  return { left, right };
}

/** The scroller's visible window, inside its inline padding. */
export function rowViewWindow(el) {
  const style = window.getComputedStyle(el);
  const padLeft = parseFloat(style.paddingLeft) || 0;
  const padRight = parseFloat(style.paddingRight) || 0;
  return {
    viewLeft: el.scrollLeft + padLeft,
    viewRight: el.scrollLeft + el.clientWidth - padRight,
  };
}
